import React, { useEffect, useRef, useState } from 'react'
import CenterContent from '../Components/CenterContent/CenterContent'
import classes from './report.module.css'
import { useTranslation } from 'react-i18next'
import SelectCheck from '../Components/SelectCheck'
import Input from '../Components/Input/Input'
import http from '../Service/http'
import dayjs from 'dayjs'
import { useReactToPrint } from 'react-to-print'
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
// import http from 'your-http-library'; // замени это на соответствующую библиотеку HTTP

function ReportContainer() {
	const { t, i18n } = useTranslation()
	const [spravki, setSpravki] = useState([])
	const [spravkiValue, setSpravkiValue] = useState([])
	const [defaultDate, setDefaultDate] = useState('')
	const [reportData, setReportData] = useState([])
	const [print, setPrint] = useState(false)
	const [date, setDate] = useState({
		begDate: new Date().toISOString().split('T')[0],
		endDate: new Date().toISOString().split('T')[0]
	})
	const getAllSpravki = async () => {
		const res = await http.post('/select/spravki')
		setSpravki(res.data.data)
	}

	const getReportDate = async () => {
		let beg = dayjs(date.begDate).format('YYYY-MM-DD HH:mm:ss')
		let end = dayjs(date.endDate).format('YYYY-MM-DD HH:mm:ss')

		const res = await http.post('/select/spravkiDate', {
			id_doc: spravkiValue.map(s => s.value),
			begDate: beg,
			endDate: end
		})
		console.log('res', res)
		if (res.data.data?.length !== null) {
			setReportData(res.data.data)
			console.log(res.data.data)
		}
	}

	const onChangeDate = e => {
		console.log({ [e.target.name]: e.target.value })
		setDate({
			...date,
			[e.target.name]: e.target.value
		})
	}

	useEffect(() => {
		getAllSpravki()
		const currentDate = new Date().toISOString().split('T')[0] // получаем текущую дату в формате YYYY-MM-DD
		setDefaultDate(currentDate) // устанавливаем текущую дату в состояние defaultDate
	}, [])

	const handleSpravki = select => {
		console.log('selectedOption', select)
		setSpravkiValue(select)
	}

	// const handleChange = (event) => {
	// 	const { value } = event.target;
	// 	setSpravkiValue(value);
	// 	onChange(value);
	//   };

	const names = [
		'Oliver Hansen',
		'Van Henry',
		'April Tucker',
		// 'Ralph Hubbard',
		// 'Omar Alexander',
		// 'Carlos Abbott',
		// 'Miriam Wagner',
		// 'Bradley Wilkerson',
		// 'Virginia Andrews',
		// 'Kelly Snyder',
	  ];

	const Print = () => {
		setPrint(true)
		setTimeout(() => {
			setPrint(false)
		}, 3000)
	}

	const ref = useRef()
	const handlePrint = useReactToPrint({
		content: () => ref.current
	})
	useEffect(() => {
		if (print) {
			handlePrint()
		}
	}, [print])

	//in component
	;<div></div>

	// const handleChange = (event) => {
	// 	const { value } = event.target;
	// 	setPersonName(
	// 	  typeof value === 'string' ? value.split(',') : value,
	// 	);
	//   };

	  const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
	  PaperProps: {
		style: {
		  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
		  width: 250,
		},
	  },
	};

	return (
		<CenterContent>
			<div className={classes.head_block}>
				<div className={classes.select_block}>
					<SelectCheck
						label='Вид справки'
						isMulti={true}
						placeholder='Выберите вид справки'
						options={spravki.map(spravki => ({
							value: spravki.id_okno_document,
							label: spravki.okno_document
						}))}
						onChange={handleSpravki}
					/>
					<Input
						label='Начало:'
						type='date'
						defaultValue={defaultDate}
						value={date.begDate}
						onChange={e => onChangeDate(e)}
						name='begDate'
					/>
					<Input
						label='Конец:'
						type='date'
						defaultValue={defaultDate}
						value={date.endDate}
						onChange={e => onChangeDate(e)}
						name='endDate'
					/>
					<button className={classes.button_modal} onClick={() => getReportDate()}>
						Поиск
					</button>
					<button className={classes.button_modal} onClick={() => Print()}>
						печать
					</button>
				</div>
				{/* <div className={classes.select_block}>
				<FormControl sx={{ width: 370 }}>
					<InputLabel id="demo-multiple-checkbox-label" style={{marginTop: '-10px'}}>
						Вид справки
					</InputLabel>
					<Select 
						style={{border: "1px solid #02a4ea"}}
						sx={{ height: 30 }}
						labelId="demo-multiple-checkbox-label"
						id="demo-multiple-checkbox"
						multiple
						value={spravkiValue}
						onChange={handleSpravki} // Здесь используйте ваш обработчик handleSpravki
						input={<OutlinedInput label="Вид справки" />} // Измените label на 'Вид справки'
						renderValue={(selected) => selected.join(', ')}
						MenuProps={MenuProps}
					>
						{spravki.map((spravki) => (
						<MenuItem key={spravki.id_okno_document} value={spravki.id_okno_document} style={{zIndex: '9999999'}}>
							<Checkbox checked={spravkiValue.indexOf(spravki.id_okno_document) > -1} />
							<ListItemText primary={spravki.okno_document} />
						</MenuItem>
						))}
					</Select>
				</FormControl>
				</div> */}


				<div className={classes.data_block} ref={ref}>
					<table className='table mt-5'>
						<thead className='bg-light'>
							<tr>
								<th style={{ width: '5%' }}>№</th>
								<th className='text-center'>Вид справки</th>
								<th className={classes.institut}>Институт</th>
								<th className='text-center'>Группа</th>
								<th className='text-center'>ФИО студента</th>
								<th className={classes.nomer_spravki}>№справки</th>
								<th className='text-center'>Дата заявки</th>
								<th className='text-center'>Вид заявки</th>
								<th className='text-center'>Дата выполнения</th>
								<th className='text-center'>Исполнитель</th>
								<th className={classes.esp}>ЭЦП</th>
							</tr>
						</thead>
						<tbody>

							{reportData.map((item, index) => (
								<tr>
									<td className='text-center'>{index + 1}</td>
									<td className='text-center'>{item.okno_document}</td>
									<td className='text-center'>{item['p23-1']}</td>
									<td className='text-center'>{item.groups}</td>
									<td className='text-center'>{item.s_fio}</td>
									<td className='text-center'>{item.reference_number}</td>
									<td className='text-center'>{item.date_insert}</td>
									<td className='text-center'>{item.status_online_offline}</td>
									<td className='text-center'>{item.date_update}</td>
									<td className='text-center'>{item.ispolnitel}</td>
									<td className='text-center'>{item.EDS_fio}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</CenterContent>
	)
}

export default ReportContainer
